export enum FormatOption {
    BOLD = 'bold',
    ITALIC = 'italic',
    UNDERLINE = 'underline',
    STRIKE = 'strike',
    BLOCKQUOTE = 'blockquote',
    CODE_BLOCK = 'code-block',
    LINK = 'link',
    IMAGE = 'image',
    CLEAN = 'clean'
  }
  
  export enum ListOption {
    ORDERED = 'ordered',
    BULLET = 'bullet'
  }
  
  export enum ScriptOption {
    SUB = 'sub',
    SUPER = 'super'
  }
  
  export enum IndentOption {
    DECREASE = '-1',
    INCREASE = '+1'
  }
  
  export enum DirectionOption {
    RTL = 'rtl'
  }
  
  export enum SizeOption {
    SMALL = 'small',
    LARGE = 'large',
    HUGE = 'huge'
  }
  
  export enum HeaderValue {
    H1 = 1,
    H2 = 2,
    H3 = 3,
    H4 = 4,
    H5 = 5,
    H6 = 6,
  }
  
  export enum AlignOption {
    LEFT = '',
    CENTER = 'center',
    RIGHT = 'right',
    JUSTIFY = 'justify'
  }
  
  // Interface for header format
  export interface IHeaderFormat {
    header: number | boolean;
  }
  
  // Interface for list format
  export interface IListFormat {
    list: ListOption;
  }
  
  // Interface for script format
  export interface IScriptFormat {
    script: ScriptOption;
  }
  
  // Interface for indent format
  export interface IIndentFormat {
    indent: IndentOption;
  }
  
  // Interface for direction format
  export interface IDirectionFormat {
    direction: DirectionOption;
  }
  
  // Interface for size format
  export interface ISizeFormat {
    size: SizeOption | (SizeOption | false)[] | false;
  }

  // Interface for header dropdown format
  export interface IHeadersFormat {
    header:   (HeaderValue | false)[];
  }
  
  // Interface for color/background format
  export interface IColorFormat {
    color: string[];
  }
  
  export interface IBackgroundFormat {
    background: string[];
  }
  
  // Interface for font format
  export interface IFontFormat {
    font: string[];
  }
  
  // Interface for align format
  export interface IAlignFormat {
    align: AlignOption[];
  }
  
  // Union type for all possible toolbar group items
  export type ToolbarGroupItem = 
    | FormatOption
    | IHeaderFormat
    | IListFormat
    | IScriptFormat
    | IIndentFormat
    | IDirectionFormat
    | ISizeFormat
    | IHeadersFormat
    | IColorFormat
    | IBackgroundFormat
    | IFontFormat
    | IAlignFormat;
  
  // Type for a toolbar group (array of items)
  export type ToolbarGroup = ToolbarGroupItem[];
  
  // Type for a complete toolbar (array of groups)
  export type ToolbarOptions = ToolbarGroup[] | false;

  export type ToolbarSettings = { disableToolbar?: boolean, disableImageDrop?: boolean,disableImagePaste?: boolean, disableTextUpdateOnChange?: boolean };